import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await axios.post('https://genzserver.mylksystems.com/login/Login', {
        username,
        password,
      }).then((response) => {
        console.log('Login response:', response.data);
        sessionStorage.setItem('isLoggedIn', 'true');
        setIsLoading(false);
        setIsLoggedIn(true);
      }).catch((error) => {
        console.error('Login error:', error);
        setError('Invalid username or password');
        setIsLoading(false);
      });
    } catch (err) {
      console.error('Error during login:', err);
      setError('Login failed. Please check your credentials and try again.');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Check if the user is already logged in
    const loggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    if (loggedIn) {
      setIsLoggedIn(true);
      window.location.href = '/';
    }
  }, [isLoggedIn]);

  return (
    <div className="page-shell login-page">
      <section className="login-art">
        <h1>Welcome back to the journey desk.</h1>
      </section>

      <section className="login-panel">
        <span className="eyebrow">Admin access</span>
        <h2>Sign in</h2>
        <p>Open the operations console to manage Sri Lanka travel experiences.</p>

        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="username" className="field mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="password" className="field mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

          <button type="submit" className="admin-button w-100" disabled={isLoading}>
            <LoginIcon fontSize="small" />
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </Form>

        {isLoggedIn && <Link to="/" style={{ display: 'none' }} />}
      </section>
    </div>
  );
}

export default Login;
